import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getAgences = async () => {
    const agences = await axios.get('/service/agences')
    .catch((e) => {
        throw new CustomException(e, 'Error fetching agences')
    })
    return agences.data
}